export const FETCH_LIST_ADMISSIONS_REQUEST = "FETCH_LIST_ADMISSIONS_REQUEST";
export const FETCH_LIST_ADMISSIONS_SUCCESS = "FETCH_LIST_ADMISSIONS_SUCCESS";
export const FETCH_LIST_ADMISSIONS_FAILURE = "FETCH_LIST_ADMISSIONS_FAILURE";

export const FETCH_ALL_LIST_ADMISSIONS_REQUEST =
  "FETCH_ALL_LIST_ADMISSIONS_REQUEST";
export const FETCH_ALL_LIST_ADMISSIONS_SUCCESS =
  "FETCH_ALL_LIST_ADMISSIONS_SUCCESS";
export const FETCH_ALL_LIST_ADMISSIONS_FAILURE =
  "FETCH_ALL_LIST_ADMISSIONS_FAILURE";

export const FETCH_ALLS_LIST_ADMISSIONS_REQUEST =
  "FETCH_ALLS_LIST_ADMISSIONS_REQUEST";
export const FETCH_ALLS_LIST_ADMISSIONS_SUCCESS =
  "FETCH_ALLS_LIST_ADMISSIONS_SUCCESS";
export const FETCH_ALLS_LIST_ADMISSIONS_FAILURE =
  "FETCH_ALLS_LIST_ADMISSIONS_FAILURE";

export const FETCH_REPORT_LIST_ADMISSIONS_REQUEST =
  "FETCH_REPORT_LIST_ADMISSIONS_REQUEST";
export const FETCH_REPORT_LIST_ADMISSIONS_SUCCESS =
  "FETCH_REPORT_LIST_ADMISSIONS_SUCCESS";
export const FETCH_REPORT_LIST_ADMISSIONS_FAILURE =
  "FETCH_REPORT_LIST_ADMISSIONS_FAILURE";

export const FETCH_ADMISSION_REQUEST = "FETCH_ADMISSION_REQUEST";
export const FETCH_ADMISSION_SUCCESS = "FETCH_ADMISSION_SUCCESS";
export const FETCH_ADMISSION_FAILURE = "FETCH_ADMISSION_FAILURE";

export const FETCH_ADMISSION_PATIENT_REQUEST =
  "FETCH_ADMISSION_PATIENT_REQUEST";
export const FETCH_ADMISSION_PATIENT_SUCCESS =
  "FETCH_ADMISSION_PATIENT_SUCCESS";
export const FETCH_ADMISSION_PATIENT_FAILURE =
  "FETCH_ADMISSION_PATIENT_FAILURE";

export const ADD_ADMISSION_REQUEST = "ADD_ADMISSION_REQUEST";
export const ADD_ADMISSION_SUCCESS = "ADD_ADMISSION_SUCCESS";
export const ADD_ADMISSION_FAILURE = "ADD_ADMISSION_FAILURE";

export const UPDATE_ADMISSION_REQUEST = "UPDATE_ADMISSION_REQUEST";
export const UPDATE_ADMISSION_SUCCESS = "UPDATE_ADMISSION_SUCCESS";
export const UPDATE_ADMISSION_FAILURE = "UPDATE_ADMISSION_FAILURE";

export const DELETE_ADMISSION_REQUEST = "DELETE_ADMISSION_REQUEST";
export const DELETE_ADMISSION_SUCCESS = "DELETE_ADMISSION_SUCCESS";
export const DELETE_ADMISSION_FAILURE = "DELETE_ADMISSION_FAILURE";

export const RESET_CURRENT_ADMISSION = "RESET_CURRENT_ADMISSION";



export const FETCH_ADMISSIONS_BY_PHONE_NUMBER_REQUEST = "FETCH_ADMISSIONS_BY_PHONE_NUMBER_REQUEST";
export const FETCH_ADMISSIONS_BY_PHONE_NUMBER_SUCCESS = "FETCH_ADMISSIONS_BY_PHONE_NUMBER_SUCCESS";
export const FETCH_ADMISSIONS_BY_PHONE_NUMBER_FAILURE = "FETCH_ADMISSIONS_BY_PHONE_NUMBER_FAILURE";
export const RESET_ADMISSIONS_BY_PHONE_NUMBER = "RESET_ADMISSIONS_BY_PHONE_NUMBER"; 

export const EDIT_ADMISSION_REQUEST = "EDIT_ADMISSION_REQUEST";
export const EDIT_ADMISSION_SUCCESS = "EDIT_ADMISSION_SUCCESS";
export const EDIT_ADMISSION_FAILURE = "EDIT_ADMISSION_FAILURE";


export const FETCH_ADMISSION_PARTICULAR_REQUEST = "FETCH_ADMISSION_PARTICULAR_REQUEST";
export const FETCH_ADMISSION_PARTICULAR_SUCCESS = "FETCH_ADMISSION_PARTICULAR_SUCCESS";
export const FETCH_ADMISSION_PARTICULAR_FAILURE = "FETCH_ADMISSION_PARTICULAR_FAILURE";
export const RESET_ADMISSION_PARTICULAR = "RESET_ADMISSION_PARTICULAR";

export const BULK_DISCHARGE_ADMISSION_REQUEST = "BULK_DISCHARGE_ADMISSION_REQUEST";
export const BULK_DISCHARGE_ADMISSION_SUCCESS = "BULK_DISCHARGE_ADMISSION_SUCCESS";
export const BULK_DISCHARGE_ADMISSION_FAILURE = "BULK_DISCHARGE_ADMISSION_FAILURE";
